import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  suppliers: [],
  supplier: {},
  totalSuppliers: 0
};

const getters = {};

const actions = {
  LOAD_SUPPLIER: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios
      .get("/suppliers/" + payload.supplierId)
      .then(response => {
        commit("SET_SUPPLIER", response.data.supplier);
      });
  },
  UPDATE_SUPPLIER: function({ commit, rootState, dispatch }, payLoad) {
    return Vue.prototype.$axios
      .post("/suppliers/" + payLoad.id, payLoad, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {});
  },
  CREATE_SUPPLIER: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .post("suppliers", payload)
      .then(response => {});
  },
  DESTROY_SUPPLIER: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .delete("suppliers/" + payload)
      .then(response => {});
  }
};

const mutations = {
  SET_SUPPLIERS: (state, suppliers) => {
    state.suppliers = suppliers;
  },
  SET_TOTAL_SUPPLIERS: (state, totalSuppliers) => {
    state.totalSuppliers = totalSuppliers;
  },
  SET_SUPPLIER: (state, supplier) => {
    state.supplier = supplier;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
